const histories = (state) => state.histories;
export default {
    histories
};
